import { ref } from 'vue'

// Global notification state
const notifications = ref([])
let notificationId = 0

export function useNotifications() {
    // Add a notification
    const addNotification = (message, type = 'success', options = {}) => {
        const id = ++notificationId
        const notification = {
            id,
            message,
            type,
            duration: options.duration || 3000,
            persistent: options.persistent || false,
            ...options
        }
        
        notifications.value.push(notification)
        return id
    }

    // Remove a notification by ID
    const removeNotification = (id) => {
        const index = notifications.value.findIndex(notification => notification.id === id)
        if (index > -1) {
            notifications.value.splice(index, 1)
        }
    }

    // Clear all notifications
    const clearNotifications = () => {
        notifications.value = []
    }

    // Convenience methods for different notification types
    const showSuccess = (message, options = {}) => {
        return addNotification(message, 'success', options)
    }

    const showError = (message, options = {}) => {
        return addNotification(message, 'error', {
            duration: 5000, // Errors stay longer by default
            ...options
        })
    }

    const showWarning = (message, options = {}) => {
        return addNotification(message, 'warning', options)
    }

    const showInfo = (message, options = {}) => {
        return addNotification(message, 'info', options)
    }

    return {
        notifications,
        addNotification,
        removeNotification,
        clearNotifications,
        showSuccess,
        showError,
        showWarning,
        showInfo
    }
} 